import { Location } from "@angular/common";
import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import {  MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "src/app/services/api/api.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { LgaSettingsModalComponent } from "../lga-settings-modal/lga-settings-modal.component";
import { ConfirmActionComponent } from "src/app/shared/components/confirm-action/confirm-action.component";
import { SuccessModalComponent } from "src/app/shared/modals/success-modal/success-modal.component";
import { ErrorModalComponent } from "src/app/shared/modals/error-modal/error-modal.component";
import { finalize } from "rxjs";


@Component({
  selector: 'app-lga-settings',
  templateUrl: './lga-settings.component.html',
  styleUrls: ['./lga-settings.component.css'],
  standalone: false
})
export class LgaSettingsComponent {



  isLoading: boolean = false;

  featureSearchForm: FormGroup;
  page: number = 0;
  selectedLimit: number = 10;


  isSaving: boolean = false;
  isEmpty: boolean = false;
  isSearching: any;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  details: any;

  // edit

  showSearch:boolean


  searchFiltersActive: boolean;

  constructor(
    private location: Location,

    private fb: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    private authenticationService: AuthService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
  ) {

  }

  initialSearchFormValues = {
    paymentStatus: '',
    assessmentYear: '',
    approvalStatus: '',
    from: '',
    to: '',
    asin: '',
    assessmentId: '',
    offset: '',
    type: 'DIRECT_TAX',
  };



  ngOnInit(): void {
    const snapshot = this.route.snapshot;

    // Initialize the form with the initial values
    this.featureSearchForm = this.fb.group({
      paymentStatus: [this.initialSearchFormValues.paymentStatus],
      assessmentYear: [this.initialSearchFormValues.assessmentYear],
      approvalStatus: [this.initialSearchFormValues.approvalStatus],
      from: [this.initialSearchFormValues.from],
      to: [this.initialSearchFormValues.to],
      asin: [this.initialSearchFormValues.asin],
      assessmentId: [this.initialSearchFormValues.assessmentId],
      offset: [this.initialSearchFormValues.offset],
      type: [this.initialSearchFormValues.type]
    });

    this.loadMDAConfigurations();
    this.initiateSearchForm();
  }

  goBack() {
    this.location.back();
  }


  initiateSearchForm() {
    this.featureSearchForm = this.fb.group({
      mdaName: [''],
      mdaCode: ['']
    });
  }


  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();
  }



  open() {
    let dialogRef = this.dialog.open(LgaSettingsModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-xl'],
      disableClose: true,
      data: {
        existingLgaSettings: this.details,
      }

    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadMDAConfigurations()
    })
  }



  view(lgaDetails: any) {

    let dialogRef = this.dialog.open(LgaSettingsModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-xl', 'scrollable-modal'],
      disableClose: true,
      data: {
        lgaDetails,
        isInPreviewMode: true,
      }
    });

    dialogRef.afterClosed().subscribe(() => {
    })
  }

 




  deleteMDAConfig(lgaConfigId: number) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you delete settings for this LGA?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.apiService.post(`/settings/config/delete?id=${lgaConfigId}`, {}).subscribe((res: any) => {
            if (res.success) {
              this.openSuccessModal(res.message)
              this.loadMDAConfigurations();
            }
            else {
              this.openErrorModal(res.message)
            }
          }, (error) => {
            this.openErrorModal(error)
          })        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  confirmApprove() {

  }


  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });
  
    dialogRef.afterClosed().subscribe(() => {
    });
  }
  
  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });
  
    dialogRef.afterClosed().subscribe(() => {
  
    });
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
  }

  clearFilterForm() {
    this.featureSearchForm.setValue(this.initialSearchFormValues);
  }

  resetSearchFilters() {
    this.clearFilterForm();
    this.showSearch = false;
    this.searchFiltersActive = false;
    this.loadMDAConfigurations();
  }





  search() {
    this.searchFiltersActive = true;
    this.loadMDAConfigurations()
  }

  loadMDAConfigurations() {
    var formData: any = new FormData();
    this.isEmpty = false;
    this.isSearching = true;

    this.num = (this.currentPage - 1) * this.pageSize;

    const searchValues = this.featureSearchForm?.value;
    formData.append('offset', this.num);

    if (searchValues) {
      // formData.append('id', this.featureSearchForm?.get('mdaName')?.value);
      // formData.append('code', this.featureSearchForm?.get('mdaCode')?.value);

    }

    const url = "/settings/config/get";

    this.apiService.post(url, formData).subscribe(
      (response) => {
        this.details = response.results;
        if (this.details.length > 0) {
          this.isLoading = false;
          this.count = Math.ceil(response.total);
          this.isEmpty = false;
          this.isSearching = false;
        } else {
          this.isLoading = false;
          this.isSearching = false;
          this.isEmpty = true;
        }
      },
      (error) => {
        this.isLoading = false;
        this.openErrorModal("Error performing this operation");
        this.isEmpty = true;
        this.isSearching = false;
      }
    );
  }

  callDb(event: any) {
    this.currentPage = event;


    this.loadMDAConfigurations();
  }


  refreshPage() {
    localStorage.removeItem("incomeToTax");
    localStorage.removeItem("taxToIncome");

    window.location.reload();
  }








  hasAccess(permissions: string[]) {
    return this.authenticationService.hasAnyPermission(permissions)
  }







}
